import React from "react";

const COLORS = {
  PENDING: { bg: "bg-slate-500/15", text: "text-slate-300", border: "border-slate-500/30", dot: "bg-slate-400" },
  RUNNING: { bg: "bg-amber-500/15", text: "text-amber-300", border: "border-amber-500/30", dot: "bg-amber-400" },
  SUCCESS: { bg: "bg-emerald-500/15", text: "text-emerald-300", border: "border-emerald-500/30", dot: "bg-emerald-400" },
  FAILED: { bg: "bg-rose-500/15", text: "text-rose-300", border: "border-rose-500/30", dot: "bg-rose-400" },
  CANCELLED: { bg: "bg-neutral-500/15", text: "text-neutral-300", border: "border-neutral-500/30", dot: "bg-neutral-400" },
};

export function RunStatusBadge({ status, size = "md" }) {
  const c = COLORS[status] || COLORS.PENDING;
  const cls = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  const pulse = status === "RUNNING" ? "animate-pulse" : "";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border font-black uppercase tracking-wider ${cls} ${c.bg} ${c.text} ${c.border}`}
      data-testid={`run-status-${status.toLowerCase()}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${c.dot} ${pulse}`} /> {status}
    </span>
  );
}
